import http from './http';

// получить всех пользователей
export const getAllUsers = async () => {
  const { data } = await http.get('/api/admin/users');
  return data.users || [];
};

export const createWholesaleUser = async (body) => {
  const { data } = await http.post('/api/admin/users/wholesale', body);
  return data.user;
};

export const getWholesaleStats = async (id) => {
  const { data } = await http.get(`/api/admin/users/${id}/wholesale-stats`);
  return data;
};

// обновить пользователя
export const updateUser = async (id, body) => {
  const { data } = await http.put(`/api/admin/users/${id}`, body);
  return data.user;
};

// удалить пользователя
export const deleteUser = async (id) => {
  const { data } = await http.delete(`/api/admin/users/${id}`);
  return data;
};

// апрув оптовика
export const approveWholesale = async (id, body = {}) => {
  const { data } = await http.post(`/api/admin/users/${id}/approve-wholesale`, body);
  return data.user;
};

export const declineWholesale = async (id, body = {}) => {
  const { data } = await http.post(`/api/admin/users/${id}/decline-wholesale`, body);
  return data.user;
};
